import { Star } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const REVIEWS = [
  {
    name: "Faith Richardson",
    title: "4 Years of Hassle-Free E-commerce",
    quote:
      "DSA has managed our Amazon and eBay stores for almost 4 years now. Sam reached out for a review today, and I am super happy to give them 5 stars.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzQ2NDMyMXww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
  {
    name: "Ruby Foster",
    title: "Ungated for Dawn & Crest",
    quote:
      "DSA unlocked Crest and Dawn for our catalog without policy friction. Sam asked if I'd drop a review — delighted to support them!",
    img: "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzQ2NDMyMXww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5",
  },
];

function Stars() {
  return (
    <div className="flex gap-1" aria-label="5 out of 5 stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-volt text-volt" />
      ))}
    </div>
  );
}

export function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="border-t border-black/10 bg-white">
      <div className="mx-auto max-w-[1600px] px-5 py-32 md:px-10 md:py-48">
        <Reveal className="flex flex-wrap items-end justify-between gap-8">
          <div>
            <Overline>Verified reviews</Overline>
            <h2 className="mt-6 max-w-3xl font-display text-4xl font-black tracking-tighter sm:text-5xl lg:text-6xl">
              Rated by the people who trust us with their stores.
            </h2>
          </div>
          <div
            data-testid="trust-rating-badge"
            className="border border-black/10 bg-[#F4F2EC] p-6"
          >
            <Stars />
            <p className="mt-3 font-display text-3xl font-black tracking-tight">
              Excellent
            </p>
            <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
              Based on 143 verified TrustCaptain reviews
            </p>
          </div>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 gap-px bg-black/10 md:grid-cols-12">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12} className={`${r.span} bg-white`}>
              <figure data-testid={`testimonial-${i}`} className="flex h-full flex-col p-8 md:p-12">
                <Stars />
                <blockquote className="mt-6 font-display text-2xl font-bold tracking-tight md:text-3xl">
                  “{r.title}”
                </blockquote>
                <p className="mt-4 font-body text-sm leading-relaxed text-ink/60">
                  {r.quote}
                </p>
                <figcaption className="mt-auto flex items-center gap-4 pt-10">
                  <img
                    src={r.img}
                    alt={r.name}
                    className="h-12 w-12 rounded-full object-cover saturate-[0.4]"
                  />
                  <div>
                    <p className="font-body text-sm font-semibold">{r.name}</p>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/40">
                      Verified client
                    </p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
